import type {
  DropdownClearOptions,
  DropdownClearPlacementWithAll,
} from '~/chords/DropdownSingleSelect/types';

/**
 * Normalize clear control placements to a consistent array shape.
 * @param placements - Raw placements from clearOptions.
 * @returns An array of placement values. Defaults to ['all'] when undefined.
 */
export function normalizeClearPlacements(
  placements: DropdownClearOptions['placements'],
): DropdownClearPlacementWithAll[] {
  if (placements === undefined) {
    return ['all'];
  }

  if (Array.isArray(placements)) {
    return placements;
  }

  return [placements];
}
